"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var useFormPermissions_exports = {};
__export(useFormPermissions_exports, {
  useFormPermissions: () => useFormPermissions
});
module.exports = __toCommonJS(useFormPermissions_exports);
var import_permission = require("@cartographerio/permission");
var import_types = require("@cartographerio/types");
var import_react = require("react");
function useFormPermissions(props) {
  const { runPermissionCheck, project, defaultSurvey, creating } = props;
  return (0, import_react.useMemo)(
    () => ({
      hasQualifications: runPermissionCheck(
        import_permission.check.and(
          ...project.qualificationRequirements.map(
            ({ qualificationId, name }) => import_permission.check.hasQualification((0, import_types.qualificationRole)(name, qualificationId))
          )
        )
      ),
      canUpdateSurveyor: runPermissionCheck(import_permission.checks.survey.updateSurveyor(project, defaultSurvey)),
      canUpdateData: runPermissionCheck(import_permission.checks.survey.updateData(project, defaultSurvey)),
      canUpdateStatus: runPermissionCheck(import_permission.checks.survey.updateStatus(project, defaultSurvey)),
      canApprove: runPermissionCheck(import_permission.checks.survey.approveWithTeam(project, defaultSurvey.teamId ?? null)),
      canCopy: !creating && runPermissionCheck(
        import_permission.checks.survey.copy(project, project, defaultSurvey.teamId ?? null, defaultSurvey.teamId ?? null)
      ),
      canDelete: !creating,
      canViewOnMap: !creating
    }),
    [creating, defaultSurvey, project, runPermissionCheck]
  );
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  useFormPermissions
});
//# sourceMappingURL=useFormPermissions.js.map
